var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"QGtleWZyYW1lcyBfMXZ5MnVwdDEgewogIDAlIHsKICAgIHRvcDogOHB4OwogICAgaGVpZ2h0OiA2NHB4OwogIH0KICA1MCUgewogICAgdG9wOiAyNHB4OwogICAgaGVpZ2h0OiAzMnB4OwogIH0KfQouXzF2eTJ1cHQwIHsKICB3aWR0aDogMTAwJTsKICBkaXNwbGF5OiBmbGV4OwogIGp1c3RpZnktY29udGVudDogY2VudGVyOwogIGFsaWduLWl0ZW1zOiBjZW50ZXI7Cn0KLl8xdnkydXB0MiB7CiAgZGlzcGxheTogaW5saW5lLWJsb2NrOwogIHBvc2l0aW9uOiByZWxhdGl2ZTsKICB3aWR0aDogODBweDsKICBoZWlnaHQ6IDgwcHg7Cn0KLl8xdnkydXB0MyB7CiAgZGlzcGxheTogaW5saW5lLWJsb2NrOwogIHBvc2l0aW9uOiBhYnNvbHV0ZTsKICBsZWZ0OiA4cHg7CiAgd2lkdGg6IDE2cHg7CiAgYmFja2dyb3VuZDogIzAwMDsKICBhbmltYXRpb246IF8xdnkydXB0MSAxLjJzIGN1YmljLWJlemllcigwLCAwLjUsIDAuNSwgMSkgaW5maW5pdGU7Cn0KLl8xdnkydXB0NCB7CiAgbGVmdDogOHB4OwogIGFuaW1hdGlvbi1kZWxheTogLTAuMjRzOwp9Ci5fMXZ5MnVwdDUgewogIGxlZnQ6IDMycHg7CiAgYW5pbWF0aW9uLWRlbGF5OiAtMC4xMnM7Cn0KLl8xdnkydXB0NiB7CiAgbGVmdDogNTZweDsKICBhbmltYXRpb24tZGVsYXk6IDA7Cn0=\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};